import { i18n } from '@/locales';
const lc = 'views.worker_fee_per_store_group_setting.store_setting_dialog.store_list_table.';
const storeCategoryTypeCode = [
    'HUB',
    'SHARED',
    'B2B',
];
export default storeCategoryTypeCode.map((code) => ({
    text: i18n.t(`${lc}store_type_${code.toLowerCase()}`),
    value: code,
}));
